export default __webpack_public_path__ + "static/media/10.01ea013d.jpg";